import React from 'react';

export interface Props {
  className?: string;
}

export const Generic40: React.FC<Props> = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.64981 1.33334L9.41538 1.56981L8.3063 3.68311L7.95767 3.9185H4V7.1457H6.17571L6.36953 7.38013L4 11.9083V14.2583H4.00064H6.34998L6.58462 14.0219L7.69348 11.9085L8.04212 11.6733H12V8.44591H9.82429L9.63058 8.20998L12 3.68354V1.33334H9.64981Z"
      fill="currentColor"
    />
  </svg>
);
Generic40.displayName = 'Generic40';

export default Generic40;
